import React from 'react';
import { useDispatch } from 'react-redux';

import GeneratePointValidFailModalView from './GeneratePointValidFailModalView';
import { pointActions } from '../../../../../../store/modules/point';

const GeneratePointValidFailModalContainer = (props) => {
  const { closeModal, validResult } = props;
  const dispatch = useDispatch();

  const handleOpenExcelBulkGeneratePointModal = () =>
    dispatch(
      pointActions.toggleModal({
        name: 'excelBulkGeneratePointModal',
        value: true,
      }),
    );

  const isInValidItem = (item) =>
    item.userIsInvalid ||
    item.cellPhoneIsInvalid ||
    item.statusIsInvalid ||
    item.typeIsInvalid ||
    item.causeIsInvalid ||
    item.amountIsInvalid ||
    item.creditIsInvalid;

  const newUserPointList = validResult.userPointList.map((item) => ({
    ...item,
    isInvalid: isInValidItem(item),
  }));

  return (
    <GeneratePointValidFailModalView
      closeModal={closeModal}
      validResult={{ ...validResult, userPointList: newUserPointList }}
      onOpenExcelBulkGeneratePointModal={handleOpenExcelBulkGeneratePointModal}
    />
  );
};

export default GeneratePointValidFailModalContainer;
